import type { ReactNode } from "react";
import { StarIcon } from "./icons";
import styles from "./Header.module.css";

interface HeaderProps {
  readonly hostLabel: string | null;
  /** Optional right-aligned actions (e.g. the notifications bell). */
  readonly actions?: ReactNode;
}

export function Header({ hostLabel, actions }: Readonly<HeaderProps>) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLogo}>
        <StarIcon />
        <span className={styles.headerTitle}>AiVA</span>
      </div>
      <div className={styles.headerRight}>
        {hostLabel && <span className={styles.headerBadge}>{hostLabel}</span>}
        {actions}
      </div>
    </div>
  );
}
